const checkboxVariables = new Map<string, { var: string; cssVar?: string; assignDefault?: string[] }>([
  [
    'checkboxBg',
    {
      var: 'components.checkbox.bg',
      cssVar: 'checkbox-bg',
      assignDefault: ['checkboxHoverBg'],
    },
  ],
  [
    'checkboxBorderRadius',
    {
      var: 'components.checkbox.borderRadius',
      cssVar: 'checkbox-border-radius',
    },
  ],
  [
    'checkboxBorderWidth',
    {
      var: 'components.checkbox.borderWidth',
      cssVar: 'checkbox-border-width',
    },
  ],
  [
    'checkboxBorderColor',
    {
      var: 'components.checkbox.borderColor',
      cssVar: 'checkbox-border-color',
      assignDefault: ['checkboxHoverBorderColor'],
    },
  ],
  [
    'checkboxCheckedBg',
    {
      var: 'components.checkbox.checked.bg',
      cssVar: 'checkbox-checked-bg',
    },
  ],
  [
    'checkboxCheckedBorderColor',
    {
      var: 'components.checkbox.checked.borderColor',
      cssVar: 'checkbox-checked-border-color',
    },
  ],
  [
    'checkboxCheckedCheckmarkColor',
    {
      var: 'components.checkbox.checked.checkmarkColor',
      cssVar: 'checkbox-checked-checkmark-color',
    },
  ],
  [
    'checkboxHoverBg',
    {
      var: 'components.checkbox.hover.bg',
      cssVar: 'checkbox-hover-bg',
    },
  ],
  [
    'checkboxHoverBorderColor',
    {
      var: 'components.checkbox.hover.borderColor',
      cssVar: 'checkbox-hover-border-color',
    },
  ],
  [
    'checkboxDisabledBg',
    {
      var: 'components.checkbox.disabled.bg',
      cssVar: 'checkbox-disabled-bg',
    },
  ],
  [
    'checkboxDisabledBorderColor',
    {
      var: 'components.checkbox.disabled.borderColor',
      cssVar: 'checkbox-disabled-border-color',
    },
  ],
  [
    'checkboxErrorBorderColor',
    {
      var: 'components.checkbox.error.borderColor',
      cssVar: 'checkbox-error-border-color',
    },
  ],
]);

export default checkboxVariables;
